/**
* Jump Link Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Jump Link Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'jump-link-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( window.innerWidth < 768 ) {
        const dropdown = document.querySelector( '.jump-link-banner-dropdown-button' );
        const dropdownButtonText = document.querySelector( '.dropdown-button-text' );
        const links = dropdown.querySelectorAll( 'a' );

        links.forEach( ( link ) => {
          link.addEventListener( 'click', function( e ) {
            dropdownButtonText.innerText = e.target.innerText;
          } );
        } );
      }

      $( '#jump-link-banner-dropdown a' ).on( 'click', function( e ) {
        e.preventDefault();
        const href = $( this ).attr( 'href' );
        const target = document.querySelector( href );
        if ( target ) {
          const bannerHeight = $( '.jump-link-container' ).hasClass( 'fixed-banner' ) ? 104 : 144;
          const topOffset = $( '.navbar' ).outerHeight() + bannerHeight;
          window.scrollTo( {
            top: target.offsetTop - topOffset,
            behavior: 'smooth',
          } );
        }
      } );

      const jumpLinkBanner = document.querySelector( '.jump-link-banner' );
      const jumpLinkContainer = document.querySelector( '.jump-link-container' );
      let topOffset = $( '.navbar' ).outerHeight() + jumpLinkContainer.offsetHeight;
      if ( $( '#wpadminbar' ).length > 0 ) {
        topOffset += $( '#wpadminbar' ).outerHeight();
      }

      window.addEventListener( 'scroll', function() {
        if ( window.scrollY + topOffset >= jumpLinkBanner.offsetTop + jumpLinkBanner.offsetHeight ) {
          jumpLinkContainer.classList.add( 'fixed-banner' );
        } else {
          jumpLinkContainer.classList.remove( 'fixed-banner' );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'jump-link-banner', COMPONENT );
} )( app );
